import React from "react";
import Header from "../../components/header1/Header1";
import { useNavigate } from "react-router-dom";

import bannerImage from "../../elements/hero-banner-landing-page.png";
import videoImage from "../../elements/Group 169.png";
import landing2 from "../../elements/Group 170 1.png";
import "./LandingPage.css";
import ReactPlayer from "react-player"

import Footer from "../../components/footer/Footer";
import card1 from "../../elements/Group 165.png";
import card2 from "../../elements/Group 166.png";
import card3 from "../../elements/Group 167.png";
import card4 from "../../elements/Group 168.png";

import image1 from "../../elements/MOU Homepage Diagrams-01-01 1.png";
import image2 from "../../elements/MOU Homepage Diagrams-01-02 1.png";
import image3 from "../../elements/MOU Homepage Diagrams-01-03 1.png";

import icon1 from "../../elements/MOU Homepage Diagrams-01-04 1.png";
import icon2 from "../../elements/MOU Homepage Diagrams-01-05 1.png";
import icon3 from "../../elements/MOU Homepage Diagrams-01-06 1.png";

import landingDiagram from "../../elements/Landing_diagram.png";
import landingPic1 from "../../elements/02.png";
import { Player } from "@lottiefiles/react-lottie-player";
import landingPic2 from "../../elements/01 1.png";
import landingPic3 from "../../elements/03.png";
import landingPic4 from "../../elements/04.png";
import { FaPlus, FaEquals } from "react-icons/fa6";
import Graph1 from "../../elements/Graph 01.json";
import Graph2 from "../../elements/Graph 02.json";
import Graph3 from "../../elements/Graph 03.json";
import Icon1 from "../../elements/Icon01.json";
import Icon2 from "../../elements/Icon02.json";
import Icon3 from "../../elements/Icon03.json";
import PartnerInstitutions from "../../components/partner/Partner";

const LandingPage = () => {
  const navigate = useNavigate();

  const cardData = [
    {
      id: 1,
      info: "AI-Amplified Learning with Coding Milestones for Enhanced Skills",
      image: card1,
    },
    {
      id: 2,
      info: "AI-Amplified Online Internship with Real-Life Industry Projects",
      image: card2,
    },
    {
      id: 3,
      info: "Coaching and Mentorship by Industry Experts",
      image: card3,
    },
    {
      id: 4,
      info: "Dynamic Portfolio Development with New-Age Engineering Expertise",
      image: card4,
    },
  ];

  const handleRegister = (e) => {
    e.preventDefault();
    navigate("/register");
  };

  return (
    <div className="landing md:mx-20">
      <Header />

      <div className="relative w-full">
        <img
          src={bannerImage}
          alt="Banner"
          className="w-full sm:h-[300px] h-auto object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-start top-0 left-0 text-white font-medium p-4 sm:p-6">
          <div className="flex flex-col w-11/12 md:w-2/5 lg:w-2/5 p-3">
            {/* <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Be The Future.</p>
      <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Be An AI Amplified</p>
      <p className="text-xl sm:text-2xl md:text-4xl leading-snug mb-1 text-left">Software Engineer.</p> */}

            <p className="text-sm  md:text-xl leading-4 md:leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Be The Future.
            </p>
            <p className="text-sm  md:text-xl leading-4 md:leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Be An AI Amplified
            </p>
            <p className="text-sm  md:text-xl leading-4 md:leading-snug mb-1 text-left break-words lg:text-3xl xl:text-4xl">
              Software Engineer.
            </p>

            <button
              className="flex justify-center items-center place-content-center w-1/2 h-1/2 md:w-3/4 ml-1 bg-white text-black text-sm md:text-xl lg:text-2xl mt-2 md:!mt-4 rounded-lg font-bold hover:bg-gray-200 transition duration-200"
              onClick={handleRegister}
            >
              Register Now
            </button>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row px-4 md:px-0 w-full justify-between gap-8 py-10 mt-2">
        <div className="flex flex-col items-center justify-center w-full md:w-1/3">
          <Player
            autoplay
            loop
            src={Graph1}
            className="w-full sm:h-[300px] h-auto object-cover mb-2"
          />
          <div className="text-xl text-[#0070c0] font-bold mb-2 text-center">
            AI Market Size
          </div>
          <div className="text-base text-[#0070c0] px-2  leading-5 text-center mb-2">
            Increase with 35.7% CAGR between 2024-2030
          </div>
          <div className="text-sm text-center mb-4">
            (Source: Markets and Markets)
          </div>

          <div className="bg-[#0070c0] px-4 py-2 text-white rounded-lg w-full text-center h-full">
            <div className="flex flex-col justify-center items-center">
              <Player
                autoplay
                loop
                src={Icon1}
                className="flex w-1/4 justify-center object-cover mb-1"
              />
              <hr className="text-white w-1/3 items-center justify-center"></hr>
            </div>
            <div className="text-lg font-semibold ">Industry Reality:</div>
            <div className="text-base font-normal leading-5">
              Exponential growth in AI/ML/Gen AI investments
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row  items-center text-2xl font-bold md:mb-14 md:place-items-end">
          <FaPlus />
        </div>

        <div className="flex flex-col items-center justify-center w-full md:w-1/3">
          <Player
            autoplay
            loop
            src={Graph2}
            className="w-full sm:h-[300px] h-auto object-cover mb-2"
          />
          <div className="text-xl text-[#0070c0] font-bold mb-2 text-center">
            Gen AI Adoption
          </div>
          <div className="text-base text-[#0070c0] px-2  leading-5 text-center mb-2">
            Gen AI deployed in Production by enterprises
          </div>
          <div className="text-sm text-center mb-4">(Source: Gartner)</div>

          <div className="bg-[#eb5651] px-4 py-2  text-white rounded-lg w-full text-center h-full">
            <div className="flex flex-col justify-center items-center">
              <Player
                autoplay
                loop
                src={Icon2}
                className="flex w-1/4 justify-center object-cover mb-1"
              />
              <hr className="text-white w-1/3 items-center justify-center"></hr>
            </div>
            <div className="text-lg font-semibold">Industry Expectation:</div>
            <div className="text-base font-normal leading-5">
              Measurable business impact from AI solutions
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row  items-center text-2xl font-bold md:mb-14 md:place-items-end">
          <FaEquals />
        </div>

        <div className="flex flex-col items-center justify-center w-full md:w-1/3">
          <Player
            autoplay
            loop
            src={Graph3}
            className="w-full sm:h-[300px] h-auto object-cover mb-2"
          />

          <div className="text-xl text-[#0070c0] font-bold mb-2 text-center">
            AI Amplified Engineers
          </div>
          <div className="text-base text-[#0070c0] px-2  leading-5 text-center mb-2">
            Software engineers using AI coding assistants
          </div>
          <div className="text-sm text-center mb-4">(Source: Gartner)</div>

          <div className="bg-[#7030a0] px-4 py-2  text-white rounded-lg w-full text-center h-full">
            <div className="flex flex-col justify-center items-center">
              <Player
                autoplay
                loop
                src={Icon3}
                className="flex w-1/4 justify-center object-cover mb-1"
              />
              <hr className="text-white w-1/3 items-center justify-center "></hr>
            </div>
            <div className="text-lg font-semibold ">Industry Demand:</div>
            <div className="text-base font-normal leading-5">
              AI Amplified Software Engineers
            </div>
          </div>
        </div>
      </div>

      <div className="mainPage text-base xl:text-4xl">
        <div className="flex flex-col md:flex-row items-center py-8 gap-6 ">
          <div className="w-full md:w-1/2">
            <img
              src={landing2}
              alt="Learning Program"
              className="w-full h-auto"
            />
          </div>
          <div className="w-full md:w-1/2 text-lg leading-relaxed text-gray-700 space-y-2 px-4 md:px-0  ">
            <p className="text-left font-medium md:text-xl sm:text-lg">
              At Agivant, we recognize the transformative power of AI. We
              believe that by integrating AI into every stage of the software
              development lifecycle, we can unlock unprecedented levels of
              efficiency, creativity, and value.
            </p>
            <p className="text-left font-medium md:text-xl sm:text-lg">
              Our AI-Amplified Software Engineering program is designed to
              bridge the skills gap and empower the next generation of engineers
              to lead in this exciting era.
            </p>
          </div>
        </div>

        {/* <div className="bg-purple-200 py-6 ">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-6">
            Agivant’s AI Amplified Software Engineering
          </h2>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-6 max-w-5xl mx-auto px-4">
            {cardData.map((card) => (
              <div key={card.id} className="flex items-center px-4 md:p-4">
                <div className="w-16 md:w-24 h-16 md:h-24 flex-shrink-0">
                  <img
                    src={card.image}
                    alt="Card"
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="text-base md:text-lg text-gray-800 text-left ml-4">
                  {card.info}
                </p>
              </div>
            ))}
          </section>
        </div> */}

        <div className="p-4 my-4 mx-4 md:mx-0 border-gray-700 border-[1.5px] border-dashed rounded-md relative">
          <div className="  flex flex-col ">
            <div className="flex flex-col md:flex-row md:space-x-6">
              <div className="flex-1 flex-col mb-0 md:mb-2 py-3">
                <div className="flex justify-center mx-2 md:mx-4 flex-col mb-6">
                  <div className="flex w-full h-full">
                    <img
                      src={landingPic1}
                      alt="AI-Amplified Online Internship"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex bg-gray-100 items-center justify-center w-full h-auto px-2 py-1 text-sm font-semibold leading-5 text-[#33449c] text-center">
                    AI-Amplified Learning with Coding Milestones for Enhanced
                    Skills
                  </div>
                </div>

                <div className="flex justify-center mx-2 md:mx-4 flex-col mb-0 md:mb-6 ">
                  <div className="flex w-full justify-center h-full">
                    <img
                      src={landingPic2}
                      alt="Coaching and Mentorship by Industry Experts"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex bg-gray-100 items-center justify-center w-full h-auto px-4 py-1 text-sm font-semibold leading-5 text-[#33449c] text-center">
                    Coaching and Mentorship by Industry Experts
                  </div>
                </div>
              </div>

              <div className="flex flex-1 items-center justify-center ">
                <img
                  src={landingDiagram}
                  alt="Coaching and Mentorship"
                  className=" h-auto  rounded-full "
                />
              </div>

              <div className="flex-1 flex-col mb-0 md:mb-2 py-3">
                <div className="flex justify-center mx-2 md:mx-4  flex-col mb-6">
                  <div className="flex w-full h-full">
                    <img
                      src={landingPic3}
                      alt="AI-Amplified Online Internship with Real-Life Industry Projects"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex bg-gray-100 items-center justify-center w-full h-auto px-2 py-1 text-sm font-semibold leading-5 text-[#33449c] text-center">
                    AI-Amplified Online Internship with Real-Life Industry
                    Projects
                  </div>
                </div>

                <div className="flex  flex-col mx-2 md:mx-4 justify-center mb-6">
                  <div className="flex w-full  h-full">
                    <img
                      src={landingPic4}
                      alt="Dynamic Portfolio Development with New-Age Engineering Expertise"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex bg-gray-100 items-center justify-center w-full h-auto px-2 py-1 text-sm font-semibold leading-5 text-[#33449c] text-center">
                    Dynamic Portfolio Development with New-Age Engineering
                    Expertise
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mx-4 py-2 absolute bottom-0 left-0 right-0 translate-y-1/2  bg-gradient-to-r from-[#EF3933] to-[#33449C] text-center rounded-full">
            <div className="text-white font-semibold text-lg">
              Future-Ready with Enhanced Job Employability
            </div>
          </div>
        </div>

        <div className="text-center py-8">
          <h2 className="text-3xl font-bold mb-6" hidden>
            Explore the Agivant Advantage
          </h2>
          <div className="flex relative w-full sm:w-11/12 lg:w-3/4 xl:w-4/5 max-w-6xl mx-auto px-4 items-center justify-center">
            <ReactPlayer
              controls={true}
              url="https://www.youtube.com/watch?v=HJRcFoFD5Xk&feature=youtu.be"
              // url="https://youtu.be/sB9yId9cfdY?si=65zNH4OIcDQVUjfq"
            />
          </div>
        </div>

        {/* <PartnerInstitutions /> */}
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
